export default {"src":"/_next/static/media/lang-icon.acef63c3.svg","height":483,"width":476};